import { useEffect, useState, type RefObject } from "react";

interface Dimensions {
  width: number;
  height: number;
}

/**
 * Custom hook to track the dimensions of a container element.
 * Updates on mount and window resize events.
 */
export function useContainerDimensions(
  containerRef: RefObject<HTMLElement | null>,
  initialDimensions: Dimensions = { width: 500, height: 300 },
): Dimensions {
  const [dimensions, setDimensions] = useState<Dimensions>(initialDimensions);

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const { width, height } = containerRef.current.getBoundingClientRect();
        setDimensions({ width, height });
      }
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, [containerRef]);

  return dimensions;
}
